import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  tooltip: {
    backgroundColor: theme.palette.primary.light,
    color: theme.palette.common.white,
    boxShadow: theme.shadows[2],
  },
  arrow: {
    color: theme.palette.primary.light,
  },
}))

export default useStyles
